module.exports = __webpack_public_path__ + "static/media/2.1dd5005c.jpg";